import ajax from '../config/ajax'
import { getJSON, post, get } from './ultile'
import globalConfig from '../utiles/globalConfig'

export default {
  state: {
    passportToken: '',
    asideTiktokPageLink: '',
    asideTiktokPageState: false
  },
  getters: {
    passportToken: state => state.passportToken,
    asideTiktokPageLink: state => state.asideTiktokPageLink,
    asideTiktokPageState: state => state.asideTiktokPageState
  },
  mutations: {
    updateAsideCustomerPageState(state, data) {
      if (data.link && data.visible) {
        const url = new URL(data.link)
        url.searchParams.set('pt', 'tiktok')
        url.searchParams.set('passportToken', state.passportToken)
        state.asideTiktokPageLink = url.toString()
      } else {
        state.asideTiktokPageLink = ''
      }
      state.asideTiktokPageState = data.visible
    }
  },
  actions: {
    tiktokLogin({ state }, params) {
      return new Promise((resolve, reject) => {
        getJSON(ajax.tiktok.login.index, params).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            try {
              globalConfig.gaStatistics('login_success', {
                login_type: 'tiktok'
              })
            } catch (e) {}
            state.passportToken = res.res.data.PASSPORT_TOKEN
            resolve(res.res.data)
          } else {
            reject({
              type: 'tiktok',
              msg: res.errmsg,
              reLogin: res.res.result === '-900251'
            })
          }
        })
      })
    },
    tiktokProductList({ state }, params) {
      return new Promise((resolve, reject) => {
        getJSON(
          ajax.tiktok.pay.showProduct,
          Object.assign({}, params, {
            passportToken: state.passportToken
          })
        ).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            resolve(res.res.data)
          } else {
            reject({ type: 'tiktok', msg: res.errmsg })
          }
        })
      })
    },
    submitTiktokPay({ state }, params) {
      return new Promise((resolve, reject) => {
        post(
          ajax.tiktok.pay.submit,
          Object.assign({}, params, {
            passportToken: state.passportToken
          }),
          {
            withCredentials: true
          }
        ).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            resolve(res.res.data)
          } else {
            reject({ type: 'tiktok', msg: res.errmsg })
          }
        })
      })
    }
  }
}
